// src/pages/BillingPage.js

import React, { useState } from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';

const BillingPage = ({ onFinish }) => {
    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);

    const handleFinishBilling = () => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            setDone(true);
        }, 5000);
    };

    if (!done && !loading) {
        return (
            <Box textAlign="center">
                <Typography variant="h5" gutterBottom>
                    Schritt 4: Verordnung abrechnen
                </Typography>
                <Button variant="contained" color="success" onClick={handleFinishBilling}>
                    Abrechnung jetzt abschließen und Daten übermitteln
                </Button>
            </Box>
        );
    }

    if (loading) {
        return (
            <Box textAlign="center">
                <CircularProgress />
                <Typography variant="body1" mt={2}>Datenübermittlung...</Typography>
            </Box>
        );
    }

    // done==true
    return (
        <Box textAlign="center">
            <Typography variant="h3" color="green">&#10003;</Typography>
            <Typography variant="h6" gutterBottom mt={2}>
                Daten erfolgreich versendet. Du kannst jetzt die Original-Verordnung versenden.
            </Typography>
            <Button variant="contained" onClick={onFinish}>
                Vorgang abschließen & neuen starten
            </Button>
        </Box>
    );
};

export default BillingPage;
